import { NotSupportedException } from 'Api/Dto/Exception';
import { Component, Prop, UIElement } from 'Framework/Components/UIElement';

export type ExpandDirection =
    | 'left'
    | 'right'
    | 'up'
    | 'down';

@Component({
    name: 'x-toggle'
})
export default class Toggle extends UIElement {
    public created(): void {
        const verticalOrHorizontal: string = this._getVerticalOrHorizontal();

        this.toggleClasses = [
            'toggle',
            `toggle-${this.direction}`,
            `toggle-${verticalOrHorizontal}`
        ];

        const [open, close]: [string, string] = this._getIcons();
        this._openIcon = `fa-chevron-${open}`;
        this._closeIcon = `fa-chevron-${close}`;
    }

    public mounted(): void {
        this.isOpen = this.defaultValue;
    }

    public toggleOpening(): void {
        this.isOpen = !this.isOpen;
    }

    private _getVerticalOrHorizontal(): 'vertical' | 'horizontal' {
        switch (this.direction) {
            case 'down':
            case 'up':
                return 'vertical';
            case 'left':
            case 'right':
                return 'horizontal';
            default:
                throw new NotSupportedException();
        }
    }

    private _getIcons(): [string, string] {
        switch (this.direction) {
            case 'down':
                return ['down', 'up'];
            case 'up':
                return ['up', 'down'];
            case 'left':
                return ['left', 'right'];
            case 'right':
                return ['right', 'left'];
            default:
                throw new NotSupportedException();
        }
    }

    public get icon(): string {
        return this.isOpen
            ? this._closeIcon
            : this._openIcon;
    }

    public isOpen: boolean = false;
    public toggleClasses: Array<string> = [];

    private _closeIcon: string = null;
    private _openIcon: string = null;

    @Prop({ type: String, required: true })
    public direction: ExpandDirection;

    @Prop({ type: Boolean, required: false, default: true })
    public defaultValue: boolean;
}
